import React, { PropsWithChildren, useMemo } from "react";

import { useTranslateError } from "../hooks";

type apiShape = {
  get: $TSFixMeFunction;
  getAll: $TSFixMeFunction;
  post: $TSFixMeFunction;
  patch: $TSFixMeFunction;
  delete: $TSFixMeFunction;
  head: $TSFixMeFunction;
  upload: $TSFixMeFunction;
  translateError: $TSFixMeFunction;
};

type WithApiProps = {
  api: apiShape;
};

const ApiContext = React.createContext<WithApiProps | null>(null);

type OwnInternalApiContextProviderProps = {
  lcmApiClient: $TSFixMeFunction;
  testApi?: $TSFixMe;
};

const defaultProps: Partial<OwnInternalApiContextProviderProps> = {
  testApi: undefined,
};

type InternalApiContextProviderProps = OwnInternalApiContextProviderProps &
  typeof defaultProps;

function InternalApiContextProvider({
  lcmApiClient,
  children,
  testApi,
}: PropsWithChildren<InternalApiContextProviderProps>) {
  const translateError = useTranslateError();

  const context = useMemo(() => {
    if (testApi) {
      const api = testApi;
      return { api };
    }
    return {
      api: {
        get: (
          url: $TSFixMe,
          parameters: $TSFixMe,
          cache = true,
          signal = undefined,
        ) => lcmApiClient(cache, true).get(url, parameters, signal),
        getAll: (
          url: $TSFixMe,
          parameters: $TSFixMe,
          cache: $TSFixMe,
          signal = undefined,
        ) => lcmApiClient(cache, true).getAll(url, parameters, signal),
        post: (
          url: $TSFixMe,
          parametersOrObject: $TSFixMe,
          objectOrNull = null,
        ) =>
          lcmApiClient(true, true).post(url, parametersOrObject, objectOrNull),
        patch: (
          url: $TSFixMe,
          parametersOrObject: $TSFixMe,
          objectOrNull = null,
        ) =>
          lcmApiClient(true, true).patch(url, parametersOrObject, objectOrNull),
        delete: (
          url: $TSFixMe,
          parametersOrObject: $TSFixMe,
          objectOrNull = null,
        ) =>
          lcmApiClient(true, true).delete(
            url,
            parametersOrObject,
            objectOrNull,
          ),
        head: (url: $TSFixMe, parameters: $TSFixMe) =>
          lcmApiClient(true, true).head(url, parameters),
        upload: (url: $TSFixMe, parameters: $TSFixMe) =>
          lcmApiClient(true, true).upload(url, parameters),
        translateError,
      },
    };
  }, [translateError]);
  return <ApiContext.Provider value={context}>{children}</ApiContext.Provider>;
}

InternalApiContextProvider.defaultProps = defaultProps;

const ApiContextProvider = InternalApiContextProvider;

const withApi = <T extends WithApiProps = WithApiProps>(
  ChildComponent: React.ComponentType<T>,
) => {
  function ComponentWithApi(props: Readonly<Omit<T, keyof WithApiProps>>) {
    return (
      <ApiContext.Consumer>
        {(context) => {
          // istanbul ignore next
          if (!context) {
            throw new Error(
              "withApi must be used inside an ApiContextProvider",
            );
          }
          return <ChildComponent {...(props as T)} {...context} />;
        }}
      </ApiContext.Consumer>
    );
  }
  ComponentWithApi.displayName =
    ChildComponent.displayName ?? ChildComponent.name;
  return ComponentWithApi;
};

export { ApiContextProvider, ApiContext, type apiShape, withApi };
